// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Brunei */
const BN = /^(?:(?:22[89]|[78]\d\d)\d{4})$/;

export default BN;
